import { render, staticRenderFns } from "./ScheduleTag.vue?vue&type=template&id=c327407e&scoped=true"
import script from "./ScheduleTag.vue?vue&type=script&lang=js"
export * from "./ScheduleTag.vue?vue&type=script&lang=js"
import style0 from "./ScheduleTag.vue?vue&type=style&index=0&id=c327407e&prod&lang=scss"
import style1 from "./ScheduleTag.vue?vue&type=style&index=1&id=c327407e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c327407e",
  null
  
)

export default component.exports